import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";
import { Space } from "types/generated";
import { CREATE_TEMPLATE_ACCESS_TYPES } from "shared/Templates/access/useCanCreateTemplate";
import { UPDATE_TEMPLATE_ACCESS_TYPES } from "shared/Templates/access/useCanManageTemplate";

const useTemplateAvailableSpaces = (isEditing: boolean): Space[] => {
  const { spaces } = useTypedContext(SpacesContext);
  const { viewer } = useTypedContext(AccountContext);

  const accessTypes = isEditing ? UPDATE_TEMPLATE_ACCESS_TYPES : CREATE_TEMPLATE_ACCESS_TYPES;

  const availableSpaces = useMemo(() => {
    return spaces?.filter((space) => {
      return hasAtLeastOneRequiredAction(accessTypes, viewer, space.id);
    });
  }, [spaces, viewer, accessTypes]);

  return availableSpaces || [];
};

export default useTemplateAvailableSpaces;
